module.exports = __webpack_public_path__ + "static/media/feishu_iuxlabs.a59bafac.mp4";